/* eslint-disable import/prefer-default-export */

export const getRandomElementFromArray = <T>(arr: T[]): T => arr[Math.floor(Math.random() * arr.length)];
